import { useEffect, useState } from "react";
import { note } from "@/endpoints/dryp/note";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";

export const useGetNoteFile = (noteId: Dryp.NoteId) => {
	const noteFileApi = useAsyncStateStore(note.getNoteMediaFile);
	const [fileUrl, setFileUrl] = useState<string | null>(null);

	useEffect(() => {
		if (noteFileApi.data instanceof Blob) {
			const url = URL.createObjectURL(noteFileApi.data);
			setFileUrl(url);
			return () => URL.revokeObjectURL(url);
		}
		setFileUrl(null);
	}, [noteFileApi.data]);

	const fetchNoteFile = () => {
		if (!noteFileApi.loaded && !noteFileApi.loading) {
			noteFileApi.fetch(noteId);
		}
	};

	return {
		fetchNoteFile,
		loading: noteFileApi.loading,
		loaded: noteFileApi.loaded,
		fileUrl,
		error: noteFileApi.error,
		mime: noteFileApi.data instanceof Blob ? noteFileApi.data.type : undefined,
	};
};
